/**
 * 通用实体解析器 `POST /system/entities/resolve`（main-api 设计 2026-10-21-entity-lookup-design §2.4）。
 * Web 全局搜索用 `mode: "search"`：每类各回它最好的一档，每类最多 `limitPerType` 条（方案 2026-10-22-global-search-design §4 B1）。
 * 后端按调用人的读权限和数据范围过滤：没权限的类不返回，前端不另判断。
 */
import axios from './axios-config'
import type { SnowflakeId } from '@/types/snowflake'

/** 一条候选。`detail` 的键随类型不同（预订：confirmation_code / check_in / property …；房源：address / group …） */
export interface EntityRef {
  entityType: string
  entityId: SnowflakeId
  label: string
  /** 完全命中（名字、代码、编号整值相等，或按 id 找到） */
  exact: boolean
  detail?: Record<string, unknown> | null
}

export interface ResolveEntitiesRequest {
  identifiers: string[]
  /** 显式类型列表；不传 `"*"`——哪一类能打开由前端登记表定 */
  types: string[]
  mode?: 'resolve' | 'search'
  limitPerType?: number
  exactOnly?: boolean
}

interface ResolveEntitiesResponse {
  results: Record<string, EntityRef[]>
}

export const entitiesApi = {
  resolve: async (body: ResolveEntitiesRequest, signal?: AbortSignal): Promise<Record<string, EntityRef[]>> => {
    const res = await axios.post<unknown, ResolveEntitiesResponse>('/system/entities/resolve', body, { signal })
    return res?.results ?? {}
  },
}
